import React from "react";

const Logo = () => {
	return (
		<div className="splashdtf-logo" />
	);
};

export default Logo;



// WEBPACK FOOTER //
// ./src/apps/splash_desktop/components/Logo.jsx